/**
 * Live now banner (spec 11 card 1, §3.4 row 1): a followed meeting is in session and a match came up.
 * "Join here" opens the meeting at the moment the match came up, not at the start. The red dot's
 * soft ring is the app's only looping animation (motion 3).
 */
import { Play } from "lucide-react";
import { useFollowing } from "../../stores/followingStore";
import { clock } from "../../lib/format";
import { liveHeadline } from "../../lib/followText";

export function LiveBanner() {
  const live = useFollowing((s) => s.live);
  const body = useFollowing((s) => (s.live ? s.meetings.find((m) => m.id === s.live!.meetingId)?.body ?? null : null));
  if (!live) return null;
  const href = `/dashboard/meetings/${encodeURIComponent(live.meetingId)}?t=${clock(live.at)}`;
  return (
    <div className="live-banner" role="status">
      <span className="live-pulse" aria-hidden />
      <span className="live-banner__text">
        <span className="live-banner__title">{liveHeadline(live)}</span>
        <span className="live-banner__sub">{[body, "live", `came up at ${clock(live.at)}`].filter(Boolean).join(" · ")}</span>
      </span>
      <a className="live-banner__join" href={href}><Play size={12} />Join here</a>
    </div>
  );
}
